// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing-page { background: var(--bg); min-height: 100vh; padding: 32px 0 80px; }

.listing-state {
  text-align: center;
  padding: 80px 20px;
  color: var(--muted);
  font-size: 14px;
}
.listing-state--err { color: #f85149; }

.listing-grid {
  display: grid;
  grid-template-columns: minmax(280px, 360px) 1fr 320px;
  gap: 32px;
  align-items: start;
}

/* ── Gallery ── */
.listing-gallery { display: flex; flex-direction: column; gap: 12px; }
.gallery-main {
  width: 100%;
  aspect-ratio: 1 / 1;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gallery-main img { width: 100%; height: 100%; object-fit: contain; background: var(--surface); }
.gallery-empty { color: var(--muted); font-size: 13px; }

.gallery-thumbs {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 6px;
}
.gallery-thumb {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  transition: border-color .15s;
}
.gallery-thumb:hover { border-color: var(--teal); }
.gallery-thumb--active { border-color: var(--teal); box-shadow: 0 0 0 1px var(--teal); }
.gallery-thumb img { width: 100%; height: 100%; object-fit: cover; }

/* ── Info column ── */
.listing-info { display: flex; flex-direction: column; gap: 18px; }
.listing-eyebrow {
  font-size: 11px; font-weight: 600;
  letter-spacing: .12em; text-transform: uppercase;
  color: var(--teal-dark);
}
.listing-title {
  font-size: clamp(22px, 3vw, 30px);
  font-weight: 700;
  letter-spacing: -.02em;
  line-height: 1.2;
  color: var(--ink);
}

.spec-block {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 4px 18px;
}
.spec-row {
  display: grid;
  grid-template-columns: 180px 1fr;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid var(--line-soft);
  font-size: 13px;
}
.spec-row:last-child { border-bottom: 0; }
.spec-label { color: var(--muted); font-size: 12px; }
.spec-value { color: var(--ink); font-weight: 500; }

.listing-desc {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 16px 18px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--ink80);
  white-space: pre-line;
}

/* ── Side column ── */
.listing-side { display: flex; flex-direction: column; gap: 16px; position: sticky; top: 80px; }
.side-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 18px;
}
.side-eyebrow {
  font-size: 11px;
  letter-spacing: .1em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 10px;
}
.side-owner {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
}
.side-owner__av {
  width: 44px; height: 44px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--teal);
}
.side-owner__name { font-size: 14px; font-weight: 600; color: var(--ink); }
.side-owner__loc  { font-size: 12px; color: var(--muted); margin-top: 2px; }

.side-price {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -.02em;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
}
.side-action {
  margin-top: 6px;
  font-size: 12px;
  color: var(--muted);
}

.price-stats { display: flex; flex-direction: column; gap: 8px; }
.price-stats__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: 14px;
}
.price-stats__label { color: var(--muted); font-weight: 600; }
.price-stats__val { color: var(--ink); font-weight: 700; font-variant-numeric: tabular-nums; }

.seller-card { padding: 14px 16px; }
.seller-card__name {
  font-size: 14px;
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 10px;
}
.seller-card__btn {
  display: block;
  width: 100%;
  text-align: center;
  text-decoration: none;
  padding: 10px 12px;
  font-size: 13px;
}

/* ── Paywall ── */
.paywall-box {
  border: 1px dashed var(--line);
  border-radius: 10px;
  padding: 14px;
  background: var(--bg);
}
.paywall-box--inline {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 16px 18px;
  border-style: dashed;
}
.paywall-eyebrow {
  font-size: 11px;
  letter-spacing: .1em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 6px;
}
.paywall-text {
  font-size: 12px;
  color: var(--muted);
  line-height: 1.5;
}

@media (max-width: 1100px) {
  .listing-grid { grid-template-columns: 1fr; }
  .listing-side { position: static; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Listing.css"],"names":[],"mappings":"AAAA,gBAAgB,qBAAqB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE;;AAEhF;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA,sBAAsB,cAAc,EAAE;;AAEtC;EACE,aAAa;EACb,qDAAqD;EACrD,SAAS;EACT,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACrE;EACE,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,oBAAoB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,0BAA0B,EAAE;AAChG,iBAAiB,mBAAmB,EAAE,eAAe,EAAE;;AAEvD;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA,uBAAuB,yBAAyB,EAAE;AAClD,yBAAyB,yBAAyB,EAAE,iCAAiC,EAAE;AACvF,qBAAqB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAEnE,sBAAsB;AACtB,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAClE;EACE,eAAe,EAAE,gBAAgB;EACjC,qBAAqB,EAAE,yBAAyB;EAChD,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,eAAe;AACjB;AACA,uBAAuB,gBAAgB,EAAE;AACzC,cAAc,mBAAmB,EAAE,eAAe,EAAE;AACpD,cAAc,iBAAiB,EAAE,gBAAgB,EAAE;;AAEnD;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAC/F;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC1E,oBAAoB,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAE3E;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;AACjB;AACA,sBAAsB,mBAAmB,EAAE,gBAAgB,EAAE;AAC7D,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,kCAAkC,EAAE;;AAE7F,eAAe,kBAAkB,EAAE;AACnC;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB,0BAA0B,EAAE;EAC5C,gBAAgB,gBAAgB,EAAE;AACpC","sourcesContent":[".listing-page { background: var(--bg); min-height: 100vh; padding: 32px 0 80px; }\n\n.listing-state {\n  text-align: center;\n  padding: 80px 20px;\n  color: var(--muted);\n  font-size: 14px;\n}\n.listing-state--err { color: #f85149; }\n\n.listing-grid {\n  display: grid;\n  grid-template-columns: minmax(280px, 360px) 1fr 320px;\n  gap: 32px;\n  align-items: start;\n}\n\n/* ── Gallery ── */\n.listing-gallery { display: flex; flex-direction: column; gap: 12px; }\n.gallery-main {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.gallery-main img { width: 100%; height: 100%; object-fit: contain; background: var(--surface); }\n.gallery-empty { color: var(--muted); font-size: 13px; }\n\n.gallery-thumbs {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 6px;\n}\n.gallery-thumb {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 6px;\n  padding: 0;\n  cursor: pointer;\n  overflow: hidden;\n  aspect-ratio: 1 / 1;\n  transition: border-color .15s;\n}\n.gallery-thumb:hover { border-color: var(--teal); }\n.gallery-thumb--active { border-color: var(--teal); box-shadow: 0 0 0 1px var(--teal); }\n.gallery-thumb img { width: 100%; height: 100%; object-fit: cover; }\n\n/* ── Info column ── */\n.listing-info { display: flex; flex-direction: column; gap: 18px; }\n.listing-eyebrow {\n  font-size: 11px; font-weight: 600;\n  letter-spacing: .12em; text-transform: uppercase;\n  color: var(--teal-dark);\n}\n.listing-title {\n  font-size: clamp(22px, 3vw, 30px);\n  font-weight: 700;\n  letter-spacing: -.02em;\n  line-height: 1.2;\n  color: var(--ink);\n}\n\n.spec-block {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 4px 18px;\n}\n.spec-row {\n  display: grid;\n  grid-template-columns: 180px 1fr;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--line-soft);\n  font-size: 13px;\n}\n.spec-row:last-child { border-bottom: 0; }\n.spec-label { color: var(--muted); font-size: 12px; }\n.spec-value { color: var(--ink); font-weight: 500; }\n\n.listing-desc {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 16px 18px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--ink80);\n  white-space: pre-line;\n}\n\n/* ── Side column ── */\n.listing-side { display: flex; flex-direction: column; gap: 16px; position: sticky; top: 80px; }\n.side-card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 18px;\n}\n.side-eyebrow {\n  font-size: 11px;\n  letter-spacing: .1em;\n  text-transform: uppercase;\n  color: var(--muted);\n  margin-bottom: 10px;\n}\n.side-owner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n  color: inherit;\n}\n.side-owner__av {\n  width: 44px; height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--teal);\n}\n.side-owner__name { font-size: 14px; font-weight: 600; color: var(--ink); }\n.side-owner__loc  { font-size: 12px; color: var(--muted); margin-top: 2px; }\n\n.side-price {\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -.02em;\n  color: var(--ink);\n  font-variant-numeric: tabular-nums;\n}\n.side-action {\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.price-stats { display: flex; flex-direction: column; gap: 8px; }\n.price-stats__row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  font-size: 14px;\n}\n.price-stats__label { color: var(--muted); font-weight: 600; }\n.price-stats__val { color: var(--ink); font-weight: 700; font-variant-numeric: tabular-nums; }\n\n.seller-card { padding: 14px 16px; }\n.seller-card__name {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ink);\n  margin-bottom: 10px;\n}\n.seller-card__btn {\n  display: block;\n  width: 100%;\n  text-align: center;\n  text-decoration: none;\n  padding: 10px 12px;\n  font-size: 13px;\n}\n\n/* ── Paywall ── */\n.paywall-box {\n  border: 1px dashed var(--line);\n  border-radius: 10px;\n  padding: 14px;\n  background: var(--bg);\n}\n.paywall-box--inline {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 16px 18px;\n  border-style: dashed;\n}\n.paywall-eyebrow {\n  font-size: 11px;\n  letter-spacing: .1em;\n  text-transform: uppercase;\n  color: var(--muted);\n  margin-bottom: 6px;\n}\n.paywall-text {\n  font-size: 12px;\n  color: var(--muted);\n  line-height: 1.5;\n}\n\n@media (max-width: 1100px) {\n  .listing-grid { grid-template-columns: 1fr; }\n  .listing-side { position: static; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
